import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// A pushed Card screen uses the platform navigation bar as its only chrome.
// Rails still owns permissions and behavior: every native item points back
// to an HTML control, so opening the Card panel or the Note editor follows
// exactly the same web path as before.
export default class extends BridgeComponent {
  static component = "card-screen-chrome"
  static targets = ["action"]
  static values = { configuration: Object }

  connect() {
    super.connect()

    this.send("connect", this.configurationValue, (message) => {
      const action = this.actionTargets.find(
        (element) => element.dataset.nativeActionId === message.data?.action
      )

      action?.click()
    })
  }

  disconnect() {
    this.send("disconnect")
    super.disconnect()
  }
}
